"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  searchBox: {
    border: "1px solid rgba(0,0,0,0.24)",
    boxSizing: 'border-box',
    width: '75%',
    maxWidth: '75%',
    height: 30,
    margin: 10,
    borderRadius: 1,
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    outline: 'none',
    padding: '0px 10px',
    textOverflow: 'ellipses',
    textAlign: 'left'
  }
};
exports["default"] = _default;